<template>
    <div>
      <div id="threesceneqqqq" :style="background"></div>
      <div class="title-logo">
        数知了仓储环境监测3D可视化系统
      </div>
  
      <div class="popup" v-show="popup" :style="weizhi">
        <h3>{{smokeName}}</h3>
        <div class="shebei">
          <div class="yanye">
            <div>产地</div>
            <span>云南</span>
          </div>
          <div class="yanye">
            <div>年份</div>
            <span>2022</span>
          </div>
          <div class="yanye">
            <div>等级</div>
            <span>3级</span>
          </div>
          <div class="yanye">
            <div>档次</div>
            <span>6档</span>
          </div>
          <div class="yanye">
            <div>数量</div>
            <span>1石</span>
          </div>
        </div> 
      </div>
  
    </div>
  </template>
  
  
  
  <script>
  import * as THREE from "three";
  import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
  import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader";
  import {
    getScene,
    getAxesHelper,
    createPoint,
    createAmbient,
    createGround,
    createCamera,
    createWebGLRenderer,
    createWallMaterail,
    createWallObject,
    createResultBsp,
    createWindow,
    createDoor,
    createPillar,
    createSmokecrib,
    createSub,
    createSub1,
    createElevator,
    createRaycaster,
    cteateVector2,
  } from "../js/threejs.js";
  import { EffectComposer } from "three/examples/jsm/postprocessing/EffectComposer.js"
  import { RenderPass } from "three/examples/jsm/postprocessing/RenderPass.js"
  import { OutlinePass } from "three/examples/jsm/postprocessing/OutlinePass.js"
  import { ShaderPass } from "three/examples/jsm/postprocessing/ShaderPass.js"
  import { FXAAShader } from "three/examples/jsm/shaders/FXAAShader.js"
  export default {
    name: "Building",
    data() {
      return {
        popup:false,
        scene: null,
        camera: null,
        renderer: null,
        composer:null,
        width: 0,
        height: 0,
        matArrayB: [],
        raycaster: null,
        mouse: null,
        ambienthumiture: [], //环境温湿度铭牌集合
        corehumiture: [], //包芯温湿度铭牌集合
        background: {
          backgroundImage: "url('../img/icons/bcImg.png')",
          backgroundRepeat: "no-repeat",
          position: "fixed",
          backgroundSize: "100% 100%",
        },
        datahm: [{ 'mac': '123', data: ['20℃', '30%'] }],
        group: new THREE.Group(),
        weizhi:{left:'100px',top:'100px'
        },
        smokeName:'111'
      };
    },
    mounted() {
      this.init();
      window.addEventListener("click", this.onmodelclick, false);
    },
    methods: {
      init() {
        // 初始化画布宽高
        this.scene = getScene();
        this.raycaster = createRaycaster();
        this.mouse = cteateVector2();
        ///初始化
        //loadinit();
        /**
         * 辅助坐标系  参数1000表示坐标系大小
         */
        var axisHelper = getAxesHelper(0);
        this.scene.position.set(0, -200, 0);
        this.scene.add(axisHelper);
  
  
  
        //点光源
        var point = createPoint(0x444444, 1000, 500, 0);
        this.scene.add(point); //点光源添加到场景中
        //环境光
        var ambient = createAmbient(0xcccccc);
        this.scene.add(ambient);
        //创建一个地面网格
        var ground = createGround(
          "../img/icons/shuinidi.png",
          2000,
          1000,
          this.resetRender
        );
        this.scene.add(ground);
        /**
         * 相机设置
         */
        var width = window.innerWidth; //窗口宽度
        var height = window.innerHeight; //窗口高度
        var k = width / height; //窗口宽高比
        var s = 100000; //三维场景显示范围控制系数，系数越大，显示的范围越大
        //创建相机对象
        // var camera = new THREE.OrthographicCamera(-s * k, s * k, s, -s, 1, 1000);
        this.camera = createCamera(65, k, 0.1, 100000); //0.1, 100000场景渲染开始位置，最远能看到哪里
        this.camera.position.set(0, 400, -1500); //设置相机位置
        this.camera.lookAt(this.scene.position); //设置相机方向(指向的场景对象)position
        /**
         * 创建渲染器对象
         */
        this.renderer = createWebGLRenderer();
        this.renderer.setSize(width, height); //设置渲染区域尺寸
        //this.renderer.setClearColor(0xb9d3ff, 1); //设置背景颜色
        document.getElementById("threesceneqqqq").appendChild(this.renderer.domElement); //body元素中插入canvas对象
        new OrbitControls(this.camera, this.renderer.domElement); //创建控件对象
        this.resetRender();
        //监听鼠标、键盘事件
        var controls = new OrbitControls(this.camera, this.renderer.domElement); //创建控件对象
        controls.addEventListener("change", () => {
          this.resetRender();
        });
        //renderer.rotateY(80);
        ///以下为添加具体的模型//////////////////////////////////////////////////////////////////////////////////////////
        //加载墙的材质
        this.matArrayB = createWallMaterail();
  
  
        ///添加墙（南）
        var wall = createWallObject(5, 100, 1000, 0, this.matArrayB, 1000, 50, 0, "墙面1");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 1000, 0, this.matArrayB, 1000, 160, 0, "墙面2");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 1000, 0, this.matArrayB, 1000, 270, 0, "墙面3");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 1000, 0, this.matArrayB, 1000, 380, 0, "墙面4");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 1000, 0, this.matArrayB, 1000, 490, 0, "墙面5");
        this.scene.add(wall);
  
        wall = createWallObject(5, 100, 1000, 1, this.matArrayB, -1000, 50, 0, "墙面1");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 1000, 1, this.matArrayB, -1000, 160, 0, "墙面2");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 1000, 1, this.matArrayB, -1000, 270, 0, "墙面3");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 1000, 1, this.matArrayB, -1000, 380, 0, "墙面4");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 1000, 1, this.matArrayB, -1000, 490, 0, "墙面5");
        this.scene.add(wall);
  
        wall = createWallObject(5, 100, 2000, 1.5, this.matArrayB, 0, 50, 500, "墙面1");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 2000, 1.5, this.matArrayB, 0, 160, 500, "墙面2");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 2000, 1.5, this.matArrayB, 0, 270, 500, "墙面3");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 2000, 1.5, this.matArrayB, 0, 380, 500, "墙面4");
        this.scene.add(wall);
        wall = createWallObject(5, 100, 2000, 1.5, this.matArrayB, 0, 490, 500, "墙面5");
        this.scene.add(wall);
  
        wall = createWallObject(2000, 5, 1000, 0, this.matArrayB, 0, 520, 0);
        this.scene.add(wall);
  
        ///创建挖空的墙
        wall = createWallObject(5, 100, 2000, 1.5, this.matArrayB, 0, 50, -500, "墙面1");
        var door_cube1 = createWallObject(180, 180, 5, 0, this.matArrayB, 0, 0, -500, "前门1");
        var door_cube2 = createWallObject(100, 90, 5, 0, this.matArrayB, -180, 45, -500, "电梯1");
        var door_cube3 = createWallObject(100, 90, 5, 0, this.matArrayB, 180, 45, -500, "电梯2");
        var window_cube1 = createWallObject(120, 90, 5, 0, this.matArrayB, -360, 45, -500, "窗户1");
        var window_cube2 = createWallObject(120, 90, 5, 0, this.matArrayB, 360, 45, -500, "窗户2");
        var window_cube3 = createWallObject(120, 70, 5, 0, this.matArrayB, -540, 50, -500, "窗户1");
        var window_cube4 = createWallObject(120, 70, 5, 0, this.matArrayB, 540, 50, -500, "窗户2");
        var window_cube5 = createWallObject(120, 70, 5, 0, this.matArrayB, -720, 50, -500, "窗户1");
        var window_cube6 = createWallObject(120, 70, 5, 0, this.matArrayB, 720, 50, -500, "窗户2");
        var objects_cube = [];
        objects_cube.push(door_cube1);
        objects_cube.push(door_cube2);
        objects_cube.push(door_cube3);
        objects_cube.push(window_cube1);
        objects_cube.push(window_cube2);
        objects_cube.push(window_cube3);
        objects_cube.push(window_cube4);
        objects_cube.push(window_cube5);
        objects_cube.push(window_cube6);
        var wallbsp = createResultBsp(wall, objects_cube);
        this.scene.add(wallbsp);
        //安装窗户
        var window_cube = createWindow(120, 70, 2, 0, -540, 50, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 70, 2, 0, 540, 50, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        var door_cube = createElevator(100, 90, 2, 0, -180, 45, -500, "安装门", this.resetRender);
        this.scene.add(door_cube);
        door_cube = createElevator(100, 90, 2, 0, 180, 45, -500, "安装门", this.resetRender);
        this.scene.add(door_cube);
        window_cube = createDoor(120, 90, 2, 0, -360, 45, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createDoor(120, 90, 2, 0, 360, 45, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 70, 2, 0, -720, 50, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 70, 2, 0, 720, 50, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
  
        wall = createWallObject(5, 100, 2000, 1.5, this.matArrayB, 0, 160, -500, "墙面2");
        var door_cube1 = createWallObject(180, 80, 5, 0, this.matArrayB, 0, 160, -500, "前门1");
        var window_cube1 = createWallObject(120, 50, 5, 0, this.matArrayB, -360, 160, -500, "窗户1");
        var window_cube2 = createWallObject(120, 50, 5, 0, this.matArrayB, 360, 160, -500, "窗户2");
        var window_cube3 = createWallObject(120, 50, 5, 0, this.matArrayB, -540, 160, -500, "窗户1");
        var window_cube4 = createWallObject(120, 50, 5, 0, this.matArrayB, 540, 160, -500, "窗户2");
        var window_cube5 = createWallObject(120, 50, 5, 0, this.matArrayB, -720, 160, -500, "窗户1");
        var window_cube6 = createWallObject(120, 50, 5, 0, this.matArrayB, 720, 160, -500, "窗户2");
        var objects_cube = [];
        objects_cube.push(door_cube1);
        objects_cube.push(window_cube1);
        objects_cube.push(window_cube2);
        objects_cube.push(window_cube3);
        objects_cube.push(window_cube4);
        objects_cube.push(window_cube5);
        objects_cube.push(window_cube6);
        var wallbsp = createResultBsp(wall, objects_cube);
        this.scene.add(wallbsp);
        //安装窗户
        var window_cube = createWindow(180, 80, 2, 0, 0, 160, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 50, 2, 0, -360, 160, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 50, 2, 0, 360, 160, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 50, 2, 0, -540, 160, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 50, 2, 0, 540, 160, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 50, 2, 0, -720, 160, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 50, 2, 0, 720, 160, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
  
        wall = createWallObject(5, 100, 2000, 1.5, this.matArrayB, 0, 270, -500, "墙面3");
        var door_cube1 = createWallObject(180, 80, 5, 0, this.matArrayB, 0, 270, -500, "前门1");
        var window_cube1 = createWallObject(120, 50, 5, 0, this.matArrayB, -360, 270, -500, "窗户1");
        var window_cube2 = createWallObject(120, 50, 5, 0, this.matArrayB, 360, 270, -500, "窗户2");
        var window_cube3 = createWallObject(120, 50, 5, 0, this.matArrayB, -540, 270, -500, "窗户1");
        var window_cube4 = createWallObject(120, 50, 5, 0, this.matArrayB, 540, 270, -500, "窗户2");
        var window_cube5 = createWallObject(120, 50, 5, 0, this.matArrayB, -720, 270, -500, "窗户1");
        var window_cube6 = createWallObject(120, 50, 5, 0, this.matArrayB, 720, 270, -500, "窗户2");
        var objects_cube = [];
        objects_cube.push(door_cube1);
        objects_cube.push(window_cube1);
        objects_cube.push(window_cube2);
        objects_cube.push(window_cube3);
        objects_cube.push(window_cube4);
        objects_cube.push(window_cube5);
        objects_cube.push(window_cube6);
        var wallbsp = createResultBsp(wall, objects_cube);
        this.scene.add(wallbsp);
        //安装窗户
        var window_cube = createWindow(180, 80, 2, 0, 0, 270, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 50, 2, 0, -360, 270, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 50, 2, 0, 360, 270, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 50, 2, 0, -540, 270, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 50, 2, 0, 540, 270, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 50, 2, 0, -720, 270, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 50, 2, 0, 720, 270, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
  
        wall = createWallObject(5, 100, 2000, 1.5, this.matArrayB, 0, 380, -500, "墙面4");
        var door_cube1 = createWallObject(180, 80, 5, 0, this.matArrayB, 0, 380, -500, "前门1");
        var window_cube1 = createWallObject(120, 50, 5, 0, this.matArrayB, -360, 380, -500, "窗户1");
        var window_cube2 = createWallObject(120, 50, 5, 0, this.matArrayB, 360, 380, -500, "窗户2");
        var window_cube3 = createWallObject(120, 50, 5, 0, this.matArrayB, -540, 380, -500, "窗户1");
        var window_cube4 = createWallObject(120, 50, 5, 0, this.matArrayB, 540, 380, -500, "窗户2");
        var window_cube5 = createWallObject(120, 50, 5, 0, this.matArrayB, -720, 380, -500, "窗户1");
        var window_cube6 = createWallObject(120, 50, 5, 0, this.matArrayB, 720, 380, -500, "窗户2");
        var objects_cube = [];
        objects_cube.push(door_cube1);
        objects_cube.push(window_cube1);
        objects_cube.push(window_cube2);
        objects_cube.push(window_cube3);
        objects_cube.push(window_cube4);
        objects_cube.push(window_cube5);
        objects_cube.push(window_cube6);
        var wallbsp = createResultBsp(wall, objects_cube);
        this.scene.add(wallbsp);
        //安装窗户
        var window_cube = createWindow(180, 80, 2, 0, 0, 380, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 50, 2, 0, -360, 380, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 50, 2, 0, 360, 380, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 50, 2, 0, -540, 380, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 50, 2, 0, 540, 380, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 50, 2, 0, -720, 380, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 50, 2, 0, 720, 380, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
  
        wall = createWallObject(5, 100, 2000, 1.5, this.matArrayB, 0, 490, -500, "墙面5");
        var door_cube1 = createWallObject(180, 80, 5, 0, this.matArrayB, 0, 490, -500, "前门1");
        var window_cube1 = createWallObject(120, 50, 5, 0, this.matArrayB, -360, 490, -500, "窗户1");
        var window_cube2 = createWallObject(120, 50, 5, 0, this.matArrayB, 360, 490, -500, "窗户2");
        var window_cube3 = createWallObject(120, 50, 5, 0, this.matArrayB, -540, 490, -500, "窗户1");
        var window_cube4 = createWallObject(120, 50, 5, 0, this.matArrayB, 540, 490, -500, "窗户2");
        var window_cube5 = createWallObject(120, 50, 5, 0, this.matArrayB, -720, 490, -500, "窗户1");
        var window_cube6 = createWallObject(120, 50, 5, 0, this.matArrayB, 720, 490, -500, "窗户2");
        var objects_cube = [];
        objects_cube.push(door_cube1);
        objects_cube.push(window_cube1);
        objects_cube.push(window_cube2);
        objects_cube.push(window_cube3);
        objects_cube.push(window_cube4);
        objects_cube.push(window_cube5);
        objects_cube.push(window_cube6);
        var wallbsp = createResultBsp(wall, objects_cube);
        this.scene.add(wallbsp);
        //安装窗户
        var window_cube = createWindow(180, 80, 2, 0, 0, 490, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 50, 2, 0, -360, 490, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 50, 2, 0, 360, 490, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 50, 2, 0, -540, 490, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 50, 2, 0, 540, 490, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 50, 2, 0, -720, 490, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
        window_cube = createWindow(120, 50, 2, 0, 720, 490, -500, "安装窗户", this.resetRender);
        this.scene.add(window_cube);
  
  
  
        ////添加环境铭牌
        // this.createNameplate();
        ////添加包芯铭牌
        // this.createNameplatebx();
  
      },
      ///加载模型显示
      resetRender(obj) {
        //console.log(obj);
        this.renderer.render(this.scene, this.camera);
      },
      ///加载外部模型
      ///path 模型地址
      ///posx 模型在x轴上的位置
      ///posy 模型在y轴上的位置
      ///posz 模型在z轴上的位置
      ///rotx 模型在x轴上旋转角度
      ///roty 模型在y轴上旋转角度
      ///rotz 模型在z轴上旋转角度
      ///zoomx 模型在x轴上缩放比例
      ///zoomy 模型在y轴上缩放比例
      ///zoomz 模型在z轴上缩放比例
      createFBX(path, posx, posy, posz, rotx, roty, rotz, zoomx, zoomy, zoomz, name) {
        const loader = new FBXLoader();
        let _this = this;
        loader.load(path, function (obj) {
          //obj.scale.x = obj.scale.y = obj.scale.z = 100;
          //obj.rotation.y = 500;
          obj.rotation.y = rotx;
          obj.rotation.x = roty;
          obj.rotation.z = rotz;//模型的角度
          //let mesh = obj;
          obj.position.x = posx;//模型所在位置
          obj.position.y = posy;//模型所在位置
          obj.position.z = posz;//模型所在位置
          obj.scale.set(zoomx, zoomy, zoomz);//模型缩放比例
          obj.name = name;
          _this.group.add(obj);
          _this.scene.add(_this.group);
          _this.resetRender('外部模型');
        });
      },
     
      // CanvasTexture
      getTextCanvas1(title) {
        let texts = [
          { name: "温度", value: "32℃" },
          { name: "湿度", value: "56%" },
        ];
        var width = 1000,
          height = 500;
        var canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        var ctx = canvas.getContext("2d");
        ctx.fillStyle = "#55AA77";
        ctx.fillRect(0, 0, width, height);
        ctx.font = 120 + 'px " bold';
        ctx.fillStyle = "#ffffff";
        //ctx.fillText(texts, width/2,height/2);
        ctx.fillText(title, 200, 120);
        texts.forEach((text, index) => {
          ctx.fillText(`${text.name}:${text.value}`, 230, 120 * index + 300);
        });
        return canvas;
      },
      ///点击事件
      onmodelclick(event) {
        //console.log(22222222222222222222222222222222222222222222222222);
        this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
        this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
        this.raycaster.setFromCamera(this.mouse, this.camera);
  
        // 计算物体和射线的焦点
        var intersects = this.raycaster.intersectObjects(this.scene.children);
  
        var ress = intersects.filter(function (res) {
          return res && res.object;
        });
  
        //点击事件
        var res = intersects.filter(function (res) {
          return res && res.object;
        });
        res.forEach(e => {
          if(e.object.name.indexOf("墙面")>=0){
            res=e;
            return;
          }
        });
        if (res && res.object) {
          //console.log(res)
          var selectObject = res.object;
          //var smokecrib = createSub1(150, 100, 300, -800, 50, 280, this.resetRender, selectObject.name);
          //this.bbb=selectObject.name;
          //console.log(this.scene)
          // let list = this.scene.children;
          // list.forEach((i, index) => {
          //   if (i.name == selectObject.name) {
          //     list.splice(index, 1);
          //     //this.scene.add(smokecrib);
          //     //this.ccc=selectObject.name;
          //     this.aaa=true;
          //     return;
          //   }
          // });
          let name=selectObject.name;
          window.removeEventListener('click',  this.onmodelclick, false)
          if(name=="墙面5"){
            this.outlineObj([selectObject]);
            this.$router.push("/fuliao/fivefloor");
          }else if(name=="墙面4"){
            this.outlineObj([selectObject]);
            this.$router.push("/fuliao/fourfloor");
          }else if(name=="墙面3"){
            this.outlineObj([selectObject]);
            this.$router.push("/fuliao/threefloor");
          }else if(name=="墙面2"){
            this.outlineObj([selectObject]);
            this.$router.push("/fuliao/twofloor");
          }else{
            this.outlineObj([selectObject]);
            this.$router.push("/fuliao/onefloor");
          }
          
          // if(selectObject.name.indexOf('烟垛')>=0||selectObject.name.indexOf('柱子')>=0){
            
            //this.$destroy();
            
            
            //window.location.href='/#/fuliao/onefloor';
  
            // this.smokeName=selectObject.name;
            // this.weizhi.left=event.clientX+'px';
            // this.weizhi.top=event.clientY+'px';
            // this.popup=true;
          // }
          
          
          // if (selectObject.name == "123456") {
          //   $(".contone").show();
          // } else {
          //   $(".contone").hide();
          // }
          // console.log(selectObject.name);
  
          // window.location.href = "test111.html";
        }
      },
       animate() {
      requestAnimationFrame( this.animate );
      this.renderer.render( this.scene, this.camera );
      //controls.update();
      if (this.composer) {
          this.composer.render()
        }
  },
       outlineObj (selectedObjects) {
        // 创建一个EffectComposer（效果组合器）对象，然后在该对象上添加后期处理通道。
        this.composer = new EffectComposer(this.renderer)
        // 新建一个场景通道  为了覆盖到原理来的场景上
        let renderPass = new RenderPass(this.scene, this.camera)
        this.composer.addPass(renderPass);
        let _this=this;
        // 物体边缘发光通道
        let outlinePass = new OutlinePass(new THREE.Vector2(window.innerWidth, window.innerHeight), _this.scene, _this.camera, selectedObjects)
        outlinePass.selectedObjects = selectedObjects
        outlinePass.edgeStrength = 5.0 // 边框的亮度
        outlinePass.edgeGlow = 1// 光晕[0,1]
        outlinePass.usePatternTexture = false // 是否使用父级的材质
        outlinePass.edgeThickness = 10.0 // 边框宽度
        outlinePass.downSampleRatio = 1 // 边框弯曲度
        outlinePass.pulsePeriod = 2 // 呼吸闪烁的速度
        outlinePass.visibleEdgeColor.set(parseInt(0x00ff00)) // 呼吸显示的颜色
        outlinePass.hiddenEdgeColor = new THREE.Color(0, 0, 0) // 呼吸消失的颜色
        outlinePass.clear = true
        this.composer.addPass(outlinePass)
        // 自定义的着色器通道 作为参数
        var effectFXAA = new ShaderPass(FXAAShader)
        effectFXAA.uniforms.resolution.value.set(1 / window.innerWidth, 1 / window.innerHeight)
        effectFXAA.renderToScreen = true
        this.composer.addPass(effectFXAA)
        //composer.render();
        this.animate();
      },
      //环境温湿度显示
      hjwsd(event) {
        //console.log(this.ambienthumiture);
        this.ambienthumiture.forEach((wall, index) => {
          if (event) {
            wall.visible = true;
          } else {
            wall.visible = false;
          }
        });
        this.resetRender();
      },
      //环境温湿度显示
      bxwsd(event) {
        //console.log(this.ambienthumiture);
        this.corehumiture.forEach((wall, index) => {
          if (event) {
            wall.visible = true;
          } else {
            wall.visible = false;
          }
        });
        this.resetRender();
      },
    },
  };
  </script>
  
  <style scoped>
  #threescene {
    width: 100%;
    height: 100%;
  
  }
  
  .title-logo {
    position: fixed;
    top: 0;
    width: 100%;
    height: 80px;
    color: #00ffff;
    font-family: none;
    font-size: 24px;
    font-weight: bold;
    line-height: 70px;
    background-image: url(../../../../public/img/icons/header_logo-1.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
    margin: 0 auto;
    text-align: center;
  }
  
  .contone {
    /* width: 200px;
    height: 200px; */
    z-index: 99999;
    position: absolute;
    top: 100px;
    left: 40px;
    text-align: left;
    /* border: #fff 1px solid; */
    padding: 5px 15px;
    box-shadow: 0 0 2px #00ffff inset;
    background: linear-gradient(#00ffff, #00ffff) left top, linear-gradient(#00ffff, #00ffff) left top, linear-gradient(#00ffff, #00ffff) right bottom, linear-gradient(#00ffff, #00ffff) right bottom;
    background-repeat: no-repeat;
    background-size: 1px 10px, 10px 1px;
    background-color: rgba(0, 0, 0, 0.4);
  }
  
  .biaoti {
    color: #fff;
    font-size: 16px;
    margin-right: 10px;
    line-height: 40px;
  }
  
  .ivu-switch-large {
    width: 44px !important;
  }
  
  .ivu-switch-large.ivu-switch-checked:after {
    left: 23px !important;
  }
  
  
  .popup {
    position: absolute;
    /* left: 1000px;
    top: 40%; */
    width: 320px;
    /* height: 200px; */
    box-shadow: 0 0 2px #00ffff inset;
    background-color: rgba(0, 0, 0, 0.4);
    border-top: 2px solid #00ffff;
    color: #fff;
  }
  
  .popup h3 {
    line-height: 60px;
  }
  
  .shebei {
    width: 290px;
    /* height: 80px; */
    margin: 0 auto;
  }
  
  .yanye {
    float: left;
    width: 20%;
    padding: 10px;
    margin-bottom: 15px;
    background-color: rgba(255, 255, 255, 0.2);
  }
  
  .yanye span {
    font-size: 16px;
    font-weight: bold;
    color: #00ffff;
  
  }
  
  .wendu,
  .shidu {
    float: left;
    width: 50%;
    padding: 10px;
    margin-bottom: 15px;
    background-color: rgba(255, 255, 255, 0.2);
  }
  
  .shebei img {
    float: left;
  }
  
  .shebei p {
    float: left;
    font-size: 20px;
    line-height: 45px;
    margin-left: 10px;
  }
  
  /* 侧边栏 */
  .sidebar {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    width: 240px;
    background-color: rgba(255, 255, 255, 0.1);
    /* background-color: red; */
  }
  </style>